import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
  
import {
  $showPosition,
  $showAntiques,
  $showDetail,
  $showFullScreen
} from './components/popupLayout'
Vue.use(Viewer);
Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": false, "title": false, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});
Vue.config.productionTip = false
var isProduction = process.env.NODE_ENV === 'production'
Vue.prototype.$cdn = isProduction ?'https://4dscene.4dage.com/wuhu/jiaoyulu/' : 'https://4dscene.4dage.com/wuhu/jiaoyulu/'
/* Vue.prototype.$cdn = '' */
Vue.prototype.$url = 'https://4dmodel.com/SuperTwoCustom/JiaoYuLu/'
Vue.prototype.$ALL = [];
Vue.prototype.$audio = new Audio();
Vue.mixin({
  methods: {
    $showPosition,
    $showAntiques,
    $showDetail,
    $showFullScreen
  }
})

let {axios} = require('./utils/http.js')

Vue.prototype.$http = axios
Vue.prototype.$bus = new Vue()


var vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

console.log(process.env.NODE_ENV)
console.log(vm)